export class SubscriptionMessagesSvc {
    status = '' as 'success';
    message = '';

    showSuccess(message: string) {
        this.message = message;
        this.status = 'success';
    }

    hideMassage() {
        this.status = '' as 'success';
        this.message = '';
    }
}

angular.module('animatronApp.SubscriptionMessagesSvc', [])
    .service('subscriptionMessageSvc', SubscriptionMessagesSvc);



// WEBPACK FOOTER //
// ./app/assets/javascripts/settings/subscription/messages/SubscriptionMessagesSvc.ts